<template>
  <div class="container">
    <div class="section columns is-fluid">
      <div class="mobile-view-nav has-background-white mb-5">
        <div
          class="is-flex is-justify-content-space-between is-align-items-center px-4 py-3"
          @click="openMenu =! openMenu"
        >
          <p class="menu__title has-text-weight-bold">Меню</p>
          <p>
            <font-awesome-icon class="drop" :icon="['fas', !openMenu ? 'fa-chevron-down' : 'fa-chevron-up']" />
          </p>
        </div>
        <ul v-if="openMenu" class="p-0 is-flex is-flex-direction-column is-align-self-flex-start">
          <li v-for="link in links" :key="link.title">
            <router-link
              v-if="link.url"
              class="list-item-device item-link is-block px-2 py-2"
              active-class="active"
              :to="link.url === '/' ? link.url : link.url + device_id"
              exact
            >
              {{ link.title }}
              <span v-if="link.isActiveMessages && GetMessagesData.active_msg_count" class="is-badge ml-1">
                {{ GetMessagesData.active_msg_count > 99 ? "99+" : GetMessagesData.active_msg_count }}
              </span>
            </router-link>
            <template v-else>
              <div>
                <p @click="journalExpand = !journalExpand" class="is-clickable list-item-device p-2">
                  <span class="item-link">{{ link.title }}</span>
                  <font-awesome-icon
                    v-if="link.isJournal"
                    class="is-pulled-right pt-1"
                    :icon="['fas', !journalExpand ? 'fa-chevron-down' : 'fa-chevron-up']"
                  />
                </p>
                <ul
                  v-if="link.isJournal && journalExpand"
                  ref="journalList"
                  class="is-fullwidth journal-list px-2"
                  @scroll="handleScroll"
                >
                  <router-link
                    v-for="report in reports"
                    :key="'report-' + report.id"
                    class="py-1 is-clickable journal-item"
                    style="gap: 6px"
                    tag="li"
                    active-class="journal-item-active"
                    :to="`/device/journal/${device_id}/report/${report.id}`"
                  >
                    {{ dateToLocal(report.create_time) }}
                  </router-link>
                  <li v-if="loading" class="py-1">Загрузка...</li>
                </ul>
              </div>
            </template>
          </li>
<!--          <router-link-->
<!--            v-for="link in links"-->
<!--            :key="link.url"-->
<!--            tag="li"-->
<!--            class="list-item-device p-2 has-text-centered"-->
<!--            active-class="active"-->
<!--            :to="link.url === '/' ? link.url : link.url + device_id"-->
<!--            exact-->
<!--          >-->
<!--            <a class="item-link is-size-6">-->
<!--              {{ link.title }}-->
<!--              <span v-if="link.isActiveMessages && GetMessagesData.active_msg_count" class="is-badge ml-1">-->
<!--                {{ GetMessagesData.active_msg_count > 99 ? "99+" : GetMessagesData.active_msg_count }}-->
<!--              </span>-->
<!--            </a>-->
<!--          </router-link>-->
        </ul>
      </div>
      <div class="desktop-view-nav">
        <ul class="device-views mx-4 column p-0 has-background-white is-flex is-flex-direction-column is-align-self-flex-start">
          <li v-for="link in links" :key="link.title">
            <router-link
              v-if="link.url"
              class="list-item-device item-link is-block px-2 py-2"
              active-class="active"
              :to="link.url === '/' ? link.url : link.url + device_id"
              exact
            >
              {{ link.title }}
              <span v-if="link.isActiveMessages && GetMessagesData.active_msg_count" class="is-badge ml-1">
                {{ GetMessagesData.active_msg_count > 99 ? "99+" : GetMessagesData.active_msg_count }}
              </span>
            </router-link>
            <template v-else>
              <div>
                <p @click="journalExpand = !journalExpand" class="is-clickable list-item-device p-2">
                  <span class="item-link">{{ link.title }}</span>
                  <font-awesome-icon
                    v-if="link.isJournal"
                    class="is-pulled-right pt-1"
                    :icon="['fas', !journalExpand ? 'fa-chevron-down' : 'fa-chevron-up']"
                  />
                </p>
                <ul
                  v-if="link.isJournal && journalExpand"
                  ref="journalList"
                  class="is-fullwidth journal-list px-2"
                  @scroll="handleScroll"
                >
                  <router-link
                    v-for="report in reports"
                    :key="'report-' + report.id"
                    class="py-1 is-clickable journal-item"
                    style="gap: 6px"
                    tag="li"
                    active-class="journal-item-active"
                    :to="`/device/journal/${device_id}/report/${report.id}`"
                  >
                    {{ dateToLocal(report.create_time) }}
                  </router-link>
                  <li v-if="loading" class="py-1">Загрузка...</li>
                </ul>
              </div>
            </template>
          </li>
        </ul>
      </div>
      <div class="device-mobile column has-background-white is-four-fifths is-relative">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import dayjs from "dayjs"

const LINKS = [
  { title: "Главная", url: "/" },
  { title: "Обзор", url: "/device/views/" },
  { title: "Активные сообщения", url: "/device/active-messages/", isActiveMessages: true },
  { title: "Архивные сообщения", url: "/device/archive-messages/" },
]

export default {
  props: ["device_id", "deviceName"],
  data: () => ({
    openMenu: false,
    isMain: false,
    links: LINKS,
    journalExpand: false,
    reports: [],
    reportMap: new Map(),
    offset: 0,
    limit: 20,
    loading: false,
    hasMore: true,
  }),
  computed: mapGetters(["GetMessagesData"]),
  watch: {
    GetMessagesData() {
      const config = this.GetMessagesData.config || {}
      this.links = [
        LINKS[0], LINKS[1],
        ...(config["trends"] ? [
          { title: "Тренды виброскорости", url: "/device/trends/vel/" },
          { title: "Тренды виброускорения", url: "/device/trends/acc/" },
        ] : []),
        ...(config["dkw"] ? [{ title: "Тренды DKW", url: "/device/trends/dkw/" }] : []),
        ...(config["trend_specters"] ? [{ title: "Тренды полос спектров", url: "/device/trends-spec/" }] : []),
        ...(config["specters"] ? [{ title: "Спектры", url: "/device/spectors/" }] : []),
        LINKS[2], LINKS[3],
        ...(config["ai"] ? [{ title: "Журнал AI", isJournal: true }] : []),
      ]
    },
    journalExpand(newValue) {
      if (newValue && this.reports.length === 0) {
        this.getReports()
      }
    },
  },
  mounted() {
    this.ChangeNavName(this.deviceName || "Обзор")
  },
  methods: {
    ...mapMutations(["ChangeNavName"]),
    async getReports() {
      if (this.loading || !this.hasMore) return

      this.loading = true
      try {
        const { data } = await this.$axios.get(
          `agents/${this.device_id}/ai-request-sets/paginate/${this.offset}/${this.limit}`,
        )
        const newReports = data?.data || []
        this.reports = [...this.reports, ...newReports]
        this.offset += this.limit
        this.hasMore = newReports.length === this.limit
      } catch (e) {
        console.error("Error fetching reports:", e)
        throw e
      } finally {
        this.loading = false
      }
    },
    handleScroll(event) {
      const element = event.target
      const isBottom =
        element.scrollHeight - element.scrollTop <= element.clientHeight + 50

      if (isBottom && !this.loading && this.hasMore) {
        this.getReports()
      }
    },
    dateToLocal(date) {
      if(!date) return "--/--/--"
      return dayjs(date).format('DD.MM.YYYY HH:mm:ss')
    }
  },
}
</script>

<style scoped>
.item-link {
  color: #0091ff;
  user-select: none;
}

.active {
  color: black;
  font-size: 17px;
  font-weight: 600;
  background-color: #edf2fa;
}

.list-item-device {
  white-space: nowrap;
}

.list-item-device:hover {
  background-color: #edf2fa;
}

.list-item-device.active {
  background-color: #edf2fa;
}

.is-badge {
  display: inline-flex;
  background-color: #0091ff;
  border-radius: 100px;
  min-width: 24px;
  height: 24px;
  width: auto;
  padding-inline: 6px;
  align-items: center;
  justify-content: center;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
}

.journal-list {
  max-height: 300px;
  overflow-y: auto;
  font-size: 14px;
}

.journal-list svg {
  width: 12px;
  height: 12px;
}

.journal-item {
  transition: .3s ease;
}

.journal-item:hover {
  padding-left: 5px;
}

.journal-item-active {
  font-weight: 700;
}

@media (max-width: 1024px) {
  .device-mobile {
    margin-bottom: 50px;
  }

  .device-views {
    margin-bottom: 50px;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
</style>
